import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";
import axios from "../../axios/AxiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AddCommentModalFormSession = ({
  isOpen,
  onClose,
  candidate,
  candidates,
  setCandidates,
  setComments,
  comments,
}) => {
  const [formData, setFormData] = useState({
    comment: "",
    type: "interne",
    commentator:
      [localStorage.getItem("firstname"), localStorage.getItem("lastname")]
        .filter(Boolean)
        .join(" ") ||
      localStorage.getItem("name") ||
      "Recruteur",
  });
  const navigate = useNavigate();

  const [saving, setSaving] = useState(false);
  const updateCandidate = async () => {
    if (saving || !formData.comment.trim()) return;
    setSaving(true);
    const next = [
      {
        ...formData,
        comment: formData.comment.trim(),
        type: "interne",
        isInternal: true,
        createdAt: Date.now(),
      },
      ...(comments || candidate.comments || []).map((comment) => ({
        ...comment,
        type: "interne",
        isInternal: true,
      })),
    ];
    try {
      await axios.post(`tempworker-candidate/${candidate._id}/update-comment`, {
        comments: next,
      });
      setComments(next);
      setCandidates?.((current) =>
        current.map((row) =>
          row._id === candidate._id ? { ...row, comments: next } : row,
        ),
      );
      toast.success("Commentaire interne ajouté.");
      onClose();
    } catch (error) {
      if (error.response?.data?.statusCode === 403) {
        localStorage.clear();
        navigate("/login");
      } else {
        toast.error("Impossible d’enregistrer le commentaire.");
      }
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateCandidate();
  };

  return (
    <Modal
      compact
      isOpen={isOpen}
      onClose={onClose}
      title="Ajouter un commentaire"
      className="max-w-lg"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-600">
          Commentaire interne · réservé à l’équipe, sans partage avec le
          candidat ni le client.
        </p>

        <div>
          <label
            htmlFor="comment"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Commentaire
          </label>
          <textarea
            id="comment"
            name="comment"
            rows={4}
            required
            value={formData.comment}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Saisissez votre commentaire ici..."
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={saving || !formData.comment.trim()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            {saving ? "Enregistrement…" : "Enregistrer"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const AddCommentModal = freshModal(AddCommentModalFormSession, "isOpen");
